var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect } from "react";
import { Layout, SidebarClasses } from "react-admin";
import { CustomAppBar } from "./CustomAppBar";
import { CustomMenu } from "./CustomMenu";
import { CustomSidebar } from "./menu/CustomSidebar";
import { TenantContext } from "@/providers/TenantContextProvider";
import { useGetOne } from "react-admin";
import cssInputLookAndFeel from "@/atoms/css-input-look-and-feel";
import { useAtomValue, useSetAtom } from "jotai";
import { applyConfigurationLanguagePolicy } from "@sequentech/ui-core";
import { ImportDataDrawer } from "./election-event/import-data/ImportDataDrawer";
import { CreateElectionEventProvider } from "@/providers/CreateElectionEventContextProvider";
import { CreateDataDrawer } from "./election-event/create/CreateElectionEventDrawer";
import { SigningProvider } from "./signing/SigningProvider";
import { SigningAction } from "@/lib/signing/types";
import { ClosedVotingCard } from "@/resources/Publish/ClosedVotingCard";
import { ReportCompletionActions, TransmissionCompletionActions, } from "@/resources/Reports/ReportSigning";
/** What a completed request of each protected action shows in its panel. */
var signingCompletionActions = (_a = {},
    _a[SigningAction.TransmitResults] = function (data) { return (_jsx(TransmissionCompletionActions, { data: data })); },
    _a[SigningAction.CloseVoting] = function (data) { return _jsx(ClosedVotingCard, { data: data }); },
    _a[SigningAction.GenerateElectionReturns] = function (data) { return (_jsx(ReportCompletionActions, { data: data })); },
    _a[SigningAction.GenerateReports] = function (data) { return (_jsx(ReportCompletionActions, { data: data })); },
    _a);
export var CustomCssReader = function () {
    var _a, _b;
    var tenantId = useContext(TenantContext).tenantId;
    var tenantData = useGetOne("sequent_backend_tenant", {
        id: tenantId,
    }).data;
    var setAtomValue = useSetAtom(cssInputLookAndFeel);
    var css = useAtomValue(cssInputLookAndFeel);
    useEffect(function () {
        var _a, _b;
        var customCss = (_b = (_a = tenantData === null || tenantData === void 0 ? void 0 : tenantData.annotations) === null || _a === void 0 ? void 0 : _a.css) !== null && _b !== void 0 ? _b : "";
        if (css !== customCss) {
            setAtomValue(customCss);
        }
    }, [(_a = tenantData === null || tenantData === void 0 ? void 0 : tenantData.annotations) === null || _a === void 0 ? void 0 : _a.css, setAtomValue, css]);
    useEffect(function () {
        var settings = tenantData === null || tenantData === void 0 ? void 0 : tenantData.settings;
        if (settings) {
            applyConfigurationLanguagePolicy(settings);
        }
    }, [(_b = tenantData === null || tenantData === void 0 ? void 0 : tenantData.settings) === null || _b === void 0 ? void 0 : _b.language_conf]);
    return _jsx(_Fragment, {});
};
var SequentSidebar = function (props) {
    return (_jsxs(CreateElectionEventProvider, { children: [_jsx(CustomCssReader, {}), _jsx(CustomSidebar, __assign({}, props, { children: _jsx(CustomMenu, __assign({}, props, { classes: SidebarClasses })) })), _jsx(CreateDataDrawer, {}), _jsx(ImportDataDrawer, { title: "electionEventScreen.import.eetitle", subtitle: "electionEventScreen.import.eesubtitle", paragraph: "electionEventScreen.import.electionEventParagraph" })] }));
};
export var CustomLayout = function (props) { return (_jsx(SigningProvider, { completionActions: signingCompletionActions, children: _jsx(Layout, __assign({}, props, { sx: {
            "width": "100%",
            "& .MuiPaper-root.RaSidebar-paper, & .MuiPaper-root.MuiAppBar-root": {
                top: "0",
                position: "sticky",
                zIndex: 100,
            },
            "& .MuiToolbar-root": {
                minHeight: "unset",
            },
            "& .RaList-main": {
                width: "50%",
            },
        }, appBar: CustomAppBar, 
        // sidebar={withCreateElectionEventProvider(SequentSidebar)}
        sidebar: SequentSidebar })) })); };
